<h4>DateTime Input Control Widget Editor</h4>
<div>
  <mat-form-field>
    <mat-label>Title Label</mat-label>
    <input matInput [(ngModel)]="widget.title" name="widget.title">
  </mat-form-field>
</div>

<widget-background-colour [widget]="widget"></widget-background-colour>


<mat-form-field>
  <mat-label>DateTime Control Input Name</mat-label>
  <input matInput [(ngModel)]="widget.controlWidgetName" name="widget.controlWidgetName">
</mat-form-field>
